
import './index.css';

export default function App() {
  return (
    <div className="container">
      <div>
    
           
           <footer class="text-center">
            This page is coded by 
            <a href="https://github.com/FlorenceNjeriM" target="_blank" rel="noreferrer"> Florence Njeri </a>, is
    <a href="https://github.com/FlorenceNjeriM/my-new-weather-app-react" target="_blank" rel="noreferrer">  open sourced on Github.</a> and <a href="https://app.netlify.com/sites/dulcet-dasik-29a598/overview" target="_blank" rel="noreferrer" > hosted on Netlify</a>
           </footer>
        </div>
    </div>
  );
}

 
